'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _forms = require('metadata/forms');

var _forms2 = require('utils/forms');

var _utilityFunctions = require('utils/utilityFunctions');

var _components2 = require('components');

var _Waiver_GAdventures = require('./Waiver_GAdventures');

var _Waiver_SmithsonianJourneys = require('./Waiver_SmithsonianJourneys');

var _Waiver_TruTravels = require('./Waiver_TruTravels');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var waiverStub = {
    PARTICIPATION_WAIVER: function PARTICIPATION_WAIVER(bookingCompany) {
        // TruTravels participation/liability waiver
        if (bookingCompany && bookingCompany.id === 13) {
            return _Waiver_TruTravels.TRUTRAVELS_PARTICIPATION_WAIVER;
        }
        // Smithsonian Journeys participation waiver
        if (bookingCompany && bookingCompany.id === 16) {
            return _Waiver_SmithsonianJourneys.SMITHSONIAN_JOURNEYS_PARTICIPATION_WAIVER;
        }
        // otherwise use G Adventures
        return _Waiver_GAdventures.GADVENTURES_PARTICIPATION_WAIVER;
    },
    LIABILITY_WAIVER: function LIABILITY_WAIVER(tourName) {
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'formLiabilityWaiver.stubText',
            defaultMessage: '{waiverText}',
            values: {
                waiverText: _react2.default.createElement(
                    'div',
                    { className: 'waiver-text' },
                    _react2.default.createElement(
                        'h2',
                        { className: 'h4-size center-text' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formLiabilityWaiver.part1.title1',
                            defaultMessage: 'ACKNOWLEDEGMENT AND ASSUMPTION OF RISK' }),
                        _react2.default.createElement(
                            'span',
                            { className: 'tourName' },
                            tourName
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formLiabilityWaiver.part2.text1',
                            defaultMessage: 'There is currently a heightened risk in travelling to one\n                                                 or more of the destinations on your trip.' })
                    )
                )
            } });
    },
    LIABILITY_WAIVER_KAYAKING: function LIABILITY_WAIVER_KAYAKING() {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'formLiabilityWaiverKayaking.stubText',
            defaultMessage: '{waiverText}',
            values: {
                waiverText: _react2.default.createElement(
                    'div',
                    { className: 'waiver-text' },
                    _react2.default.createElement(
                        'h2',
                        { className: 'h4-size center-text' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formLiabilityWaiverKayaking.part1.title1',
                            defaultMessage: 'KAYAKING ACKNOWLEDEGMENT AND ASSUMPTION OF RISK' })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formLiabilityWaiverKayaking.part1.title2',
                            defaultMessage: 'Please download and read the Kayak Package {here} which contains important information to help you prepare for this experience.',
                            values: {
                                here: _react2.default.createElement(
                                    'a',
                                    {
                                        href: 'https://media.gadventures.com/media-server/dynamic/admin/flatpages/kayak-package-oct-2019.pdf',
                                        target: '_blank' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'formLabels.formLiabilityWaiverKayaking.here',
                                        defaultMessage: 'here' })
                                )
                            }
                        })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formLiabilityWaiverKayaking.part2.text1',
                            defaultMessage: 'Please acknowledge that you have received the Kayak Package and understand\n                                that there is a heightened risk involved in this activity and that in order\n                                to take part, you will need to sign a Liability Waiver Form aboard the ship.'
                        })
                    )
                )
            } });
    },
    LIABILITY_WAIVER_CAMPING: function LIABILITY_WAIVER_CAMPING() {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'formLiabilityWaiverCamping.stubText',
            defaultMessage: '{waiverText}',
            values: {
                waiverText: _react2.default.createElement(
                    'div',
                    { className: 'waiver-text' },
                    _react2.default.createElement(
                        'h2',
                        { className: 'h4-size center-text' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formLiabilityWaiverCamping.part1.title1',
                            defaultMessage: 'CAMPING ACKNOWLEDEGMENT AND ASSUMPTION OF RISK' })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formLiabilityWaiverCamping.part1.title2',
                            defaultMessage: 'Please download and read the Camp Package {here} which contains important information to help you prepare for this experience.',
                            values: {
                                here: _react2.default.createElement(
                                    'a',
                                    {
                                        href: 'https://media.gadventures.com/media-server/dynamic/admin/flatpages/G_Adventures_Antarctica_Camping_Package_-_Updated_07.23.pdf',
                                        target: '_blank' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'formLabels.formLiabilityWaiverCamping.here',
                                        defaultMessage: 'here' })
                                )
                            }
                        })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formLiabilityWaiverCamping.part2.text1',
                            defaultMessage: 'Please acknowledge that you have received the Camp Package and understand\n                                that there is a heightened risk involved in this activity and that in order\n                                to take part, you will need to sign a Liability Waiver Form aboard the ship.'
                        })
                    )
                )
            } });
    }

    // For stubs
};var stubCompletionPrompt = {
    LIABILITY_WAIVER: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'formLabels.stubCompletionLiabilityWaiverPrompt',
        values: {
            thisDocument: _react2.default.createElement(
                'a',
                {
                    href: 'https://gadventures.com/borneo-liability-waiver/',
                    target: '_blank' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formLabels.stubCompletionLiabilityWaiverPrompt.thisDocument',
                    defaultMessage: 'this document' })
            ),
            email: _react2.default.createElement(
                'a',
                { href: 'mailto:experience@gadventures.com' },
                'experience@gadventures.com'
            )
        } }),
    LIABILITY_WAIVER_KAYAKING: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'formLabels.stubCompletionLiabilityWaiverKayakingPrompt',
        values: {
            thisDocument: _react2.default.createElement(
                'a',
                {
                    href: 'https://gadventures.com/kayak-liability-waiver/',
                    target: '_blank' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formLabels.stubCompletionLiabilityWaiverPrompt.thisDocument' })
            ),
            email: _react2.default.createElement(
                'a',
                { href: 'mailto:experience@gadventures.com' },
                'experience@gadventures.com'
            )
        } })
};

var certifyGuardianRenderProps = (0, _forms2.oneFieldObjInArrayFieldProps)({
    findProp: 'description',
    findValue: 'PARENT_OR_LEGAL_GUARDIAN',
    WrappedComponent: _components2.Input
});
var agreeForMinorRenderProps = (0, _forms2.oneFieldObjInArrayFieldProps)({
    findProp: 'description',
    findValue: 'SIGNED_FOR_MINOR',
    WrappedComponent: _components2.Input
});
var agreeForSelfRenderProps = (0, _forms2.oneFieldObjInArrayFieldProps)({
    findProp: 'description',
    findValue: 'SIGNED_BY_TRAVELLER',
    WrappedComponent: _components2.Input
});

var Waiver = function Waiver(_ref) {
    var intl = _ref.intl,
        initialValues = _ref.initialValues,
        departureServicesById = _ref.departureServicesById,
        isWaiverPax = _ref.isWaiverPax,
        checkinUrl = _ref.checkinUrl,
        waiverPassenger = _ref.waiverPassenger,
        bookingCompany = _ref.bookingCompany,
        requirementsByCode = _ref.requirementsByCode,
        bookingId = _ref.bookingId,
        waiverTypes = _ref.waiverTypes,
        isFetchingRequirementData = _ref.isFetchingRequirementData,
        handleSubmit = _ref.handleSubmit,
        error = _ref.error,
        invalid = _ref.invalid,
        pristine = _ref.pristine,
        submitSucceeded = _ref.submitSucceeded,
        submitFailed = _ref.submitFailed,
        submitting = _ref.submitting;

    var waivers = waiverTypes.map(function (waiverType) {
        return (requirementsByCode[waiverType] || []).map(function (waiver) {
            return {
                waiverType: waiverType,
                requirement: waiver,
                valuePath: (0, _forms2.generateValuePath)({
                    requirement: waiver,
                    resourceType: 'completed_agreements',
                    bookingId: bookingId
                }),
                isStub: waiver.flags.includes('OFFLINE'),
                isComplete: waiver.status === 'COMPLETE',
                isEditable: waiver.editable,
                tourName: (0, _forms2.getTourName)(departureServicesById, waiver)
            };
        });
    }).reduce(function (a, b) {
        return a.concat(b);
    }, []); // flatten map of maps

    var paxName = waiverPassenger.name.legal_first_name + ' ' + waiverPassenger.name.legal_last_name;
    var showSubmit = false;
    var waiversOutput = waivers.map(function (waiver, i) {
        var signDate = waiver.isComplete ? (0, _utilityFunctions.getResourceValue)(waiver.valuePath + '.signing_details.date', initialValues) : new Date();
        // if pax is minor today (if unsigned) or on date of signing
        var isMinorPax = waiverPassenger.date_of_birth ? (0, _utilityFunctions.isMinorOnDate)(waiverPassenger.date_of_birth, signDate) : false; // assume they're not a minor in case the date_of_birth has come back to us obfuscated
        var waiverStubVar = waiver.tourName;
        if (waiver.waiverType && waiver.waiverType === 'PARTICIPATION_WAIVER') {
            waiverStubVar = bookingCompany;
        }
        if (isWaiverPax) {
            if (!waiver.isComplete && !waiver.isEditable && !waiver.isStub) {
                return _react2.default.createElement(_components2.FormInstructionalText, { key: i, instructionalText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formWaiver.waiverComeBackLater',
                        defaultMessage: 'Once your booking is confirmed, please return here to complete\n                                             this waiver.' }) });
            } else {
                if (!waiver.isStub) {
                    showSubmit = true;
                    return _react2.default.createElement(
                        'div',
                        { key: i },
                        _react2.default.createElement(_components2.FormStubText, { stubText: waiverStub[waiver.waiverType](waiverStubVar) }),
                        isMinorPax && _react2.default.createElement(
                            'div',
                            null,
                            !waiver.isComplete && _react2.default.createElement(_components2.FormInstructionalText, {
                                instructionalText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formWaiver.mustBeSignedByParent',
                                    defaultMessage: 'Because you are currently under the age of 18, please\n                                                                 ensure your parent/guardian agrees to this waiver on your behalf.' }) }),
                            _react2.default.createElement(_components2.FieldSet, {
                                requirement: waiver.requirement,
                                fields: [{
                                    id: 'certifyGuardian',
                                    label: intl.formatMessage(_forms.formLabels.waiverCertifyGuardian),
                                    field: _react2.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                        id: 'certifyGuardian',
                                        name: waiver.valuePath + '.agreements',
                                        type: 'checkbox',
                                        requirement: waiver.requirement
                                    }, certifyGuardianRenderProps))
                                }, {
                                    id: 'acknowledgementMinor',
                                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'formLabels.waiverAcknowledgementMinor',
                                        values: {
                                            date: intl.formatDate(signDate, { year: 'numeric', month: 'short', day: 'numeric' }),
                                            paxName: _react2.default.createElement(
                                                'strong',
                                                null,
                                                paxName
                                            )
                                        } }),
                                    field: _react2.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                        id: 'acknowledgementMinor',
                                        name: waiver.valuePath + '.agreements',
                                        type: 'checkbox',
                                        requirement: waiver.requirement
                                    }, agreeForMinorRenderProps))
                                }, {
                                    id: 'guardianFirstName',
                                    label: intl.formatMessage(_forms.formLabels.waiverGuardianFirstName),
                                    field: _react2.default.createElement(_reduxForm.Field, {
                                        id: 'guardianFirstName',
                                        name: waiver.valuePath + '.signing_details.legal_guardian.name.legal_first_name',
                                        type: 'text',
                                        requirement: waiver.requirement,
                                        component: _components2.Input })
                                }, {
                                    id: 'guardianLastName',
                                    label: intl.formatMessage(_forms.formLabels.waiverGuardianLastName),
                                    field: _react2.default.createElement(_reduxForm.Field, {
                                        id: 'guardianLastName',
                                        name: waiver.valuePath + '.signing_details.legal_guardian.name.legal_last_name',
                                        type: 'text',
                                        requirement: waiver.requirement,
                                        component: _components2.Input })
                                }, {
                                    id: 'guardianEmail',
                                    label: intl.formatMessage(_forms.formLabels.waiverGuardianEmail),
                                    field: _react2.default.createElement(_reduxForm.Field, {
                                        id: 'guardianEmail',
                                        name: waiver.valuePath + '.signing_details.legal_guardian.account_email',
                                        type: 'email',
                                        requirement: waiver.requirement,
                                        component: _components2.Input })
                                }] })
                        ),
                        !isMinorPax && _react2.default.createElement(_components2.FieldSet, {
                            requirement: waiver.requirement,
                            fields: [{
                                id: 'acknowledgementSelf',
                                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formLabels.waiverAcknowledgement',
                                    values: {
                                        date: intl.formatDate(signDate, { year: 'numeric', month: 'short', day: 'numeric' }),
                                        paxName: _react2.default.createElement(
                                            'strong',
                                            null,
                                            paxName
                                        )
                                    } }),
                                field: _react2.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                    id: 'acknowledgementSelf',
                                    name: waiver.valuePath + '.agreements',
                                    type: 'checkbox',
                                    requirement: waiver.requirement
                                }, agreeForSelfRenderProps))
                            }] })
                    );
                } else {
                    return _react2.default.createElement(
                        'div',
                        { key: i },
                        _react2.default.createElement(_components2.FormStubText, { stubText: waiverStub[waiver.waiverType](waiverStubVar) }),
                        _react2.default.createElement(_components2.FieldSet, {
                            className: 'single-col',
                            requirement: waiver.requirement,
                            fields: [{
                                label: !waiver.isComplete ? stubCompletionPrompt[waiver.waiverType] : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.stubComplete' })
                            }] })
                    );
                }
            }
        } else {
            var instructionalText = void 0;
            if (!waiver.isComplete) {
                instructionalText = _react2.default.createElement(_components2.FormInstructionalText, { instructionalText: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formWaiver.waiverDifferentUserIncomplete',
                            defaultMessage: 'This waiver must be signed by {name}.',
                            values: {
                                name: isMinorPax ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formWaiver.theParentOfName',
                                    defaultMessage: 'the parent of {paxName}',
                                    values: { paxName: paxName } }) : paxName
                            } }),
                        _react2.default.createElement('hr', null),
                        _react2.default.createElement(_components2.ReminderBtn, {
                            customerId: waiverPassenger.id,
                            checkinUrl: checkinUrl,
                            emailAddress: waiverPassenger.account_email })
                    ) });
            } else {
                instructionalText = _react2.default.createElement(_components2.FormInstructionalText, { instructionalText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formWaiver.waiverDifferentUserComplete',
                        defaultMessage: 'This waiver was signed by {name}.',
                        values: {
                            name: isMinorPax ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formWaiver.theParentOfName',
                                values: { paxName: paxName } }) : paxName
                        } }) });
            }

            var staffOverride = (0, _forms2.generateOverride)({
                intl: intl,
                id: 'waiverOverride',
                requirement: waiver.requirement,
                overrideLabels: _forms.formOverrides.waiver[waiver.waiverType],
                bookingId: bookingId,
                initialValues: initialValues
            });
            if (staffOverride && !staffOverride.hideField) {
                showSubmit = true;
            }

            return _react2.default.createElement(
                'div',
                { key: i },
                _react2.default.createElement(_components2.FormStubText, { stubText: waiverStub[waiver.waiverType](waiverStubVar) }),
                instructionalText,
                staffOverride && _react2.default.createElement(_components2.FieldSet, {
                    requirement: waiver.requirement,
                    noRequirement: !!staffOverride,
                    fields: [(0, _extends3.default)({}, staffOverride)] })
            );
        }
    });

    return _react2.default.createElement(
        'form',
        null,
        showSubmit && _react2.default.createElement(_components2.FormErrorMessage, { errorCode: error, invalid: invalid, submitFailed: submitFailed, submitting: submitting }),
        waiversOutput,
        showSubmit && _react2.default.createElement(_components2.FormSubmit, {
            handleSubmit: handleSubmit,
            invalid: invalid,
            pristine: pristine,
            submitting: submitting,
            submitSucceeded: submitSucceeded,
            isFetchingRequirementData: isFetchingRequirementData })
    );
};

Waiver.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    initialValues: _propTypes2.default.object.isRequired,
    departureServicesById: _propTypes2.default.object.isRequired,
    isWaiverPax: _propTypes2.default.bool.isRequired,
    checkinUrl: _propTypes2.default.string.isRequired,
    waiverPassenger: _propTypes2.default.object.isRequired,
    requirementsByCode: _propTypes2.default.object.isRequired,
    bookingId: _propTypes2.default.string.isRequired,
    waiverTypes: _propTypes2.default.array.isRequired,
    isFetchingRequirementData: _propTypes2.default.bool.isRequired,
    handleSubmit: _propTypes2.default.func.isRequired,
    bookingCompany: _propTypes2.default.object,
    error: _propTypes2.default.string,
    invalid: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    submitSucceeded: _propTypes2.default.bool,
    submitFailed: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reduxForm.reduxForm)({
    form: 'waiver',
    enableReinitialize: true
})(Waiver));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/Waiver.js
// module id = 1330
// module chunks = 0